import { createFileRoute } from '@tanstack/react-router';

import { StitcherAccessPage } from '../features/admin/stitcherAccess/StitcherAccessPage/StitcherAccessPage';
import { stitcherAccessRouteSearchSchema } from '../features/admin/stitcherAccess/stitcherAccessRouteSearch';

export const Route = createFileRoute('/admin/stitcher-access')({
  validateSearch: stitcherAccessRouteSearchSchema,
  component: StitcherAccessPage,
});
